import React from 'react';

import {Close} from '@material-ui/icons';

export function FailIcon() {
  return <Close fontSize="small" color="error" />;
}
